import * as React from "react";
import { toINR } from "../../../../service/numberFormat";
import { marginMcxHeading } from "../../marginConstants";
import { ISortProps } from "../../../../types/components/margin/marginTypes";
import MarginSort from "../../generic/marginSort";
import { marginScrollService } from "../../../../service/marginFiles/marginScrollService";

export interface IMarginMcxTableMobProps {
	tableData: Array<any>;
	filteredData: Array<any>;
	numOfRows: number;
	sortProps: ISortProps;
	setTableData: (tableData: Array<any>) => void;
}

const MarginMcxTableMob: React.FC<IMarginMcxTableMobProps> = props => {
	const scrollBodyRef = React.useRef<HTMLUListElement>(null);
	const fixedBodyRef = React.useRef<HTMLUListElement>(null);
	const scrollHeadRef = React.useRef<HTMLUListElement>(null);

	return (
		<div className="mrgn_mcx_tbl margin_table_mob">
			<div className="fixed_col">
				<ul className="hdr_row">
					<li className="tr">
						<div className="td">
							<span className="sort_cont trdSym">
								<MarginSort
									sortList={props.filteredData}
									sortedColName={props.sortProps.sortedColumnState.colName}
									sortKey="trdSym"
									onSort={props.sortProps.onSort}
									colName={marginMcxHeading.trdSym}
								/>
							</span>
						</div>
					</li>
				</ul>
				<ul className="data_rows" ref={fixedBodyRef}>
					{props.tableData.slice(0, props.numOfRows).map((row, index) => (
						<li className="tr" key={index}>
							<div className="td">
								<span className="trdSym ib" dangerouslySetInnerHTML={{ __html: row.trdSym }}></span>
							</div>
						</li>
					))}
				</ul>
			</div>

			<div className="scrolling_cont">
				<ul className="hdr_row" ref={scrollHeadRef}>
					<li className="tr">
						<div className="td">
							<span className="sort_cont LotSize">
								<MarginSort
									sortList={props.filteredData}
									sortedColName={props.sortProps.sortedColumnState.colName}
									sortKey="LotSize"
									onSort={props.sortProps.onSort}
									colName={marginMcxHeading.lotSize}
								/>
							</span>
						</div>
						<div className="td">
							<span className="sort_cont SPANMargin">
								<MarginSort
									sortList={props.filteredData}
									sortedColName={props.sortProps.sortedColumnState.colName}
									sortKey="SPANMargin"
									onSort={props.sortProps.onSort}
									colName={marginMcxHeading.spanMargin}
								/>
							</span>
						</div>
						<div className="td">
							<span className="sort_cont ExpMargin">
								<MarginSort
									sortList={props.filteredData}
									sortedColName={props.sortProps.sortedColumnState.colName}
									sortKey="ExpMargin"
									onSort={props.sortProps.onSort}
									colName={marginMcxHeading.expMargin}
								/>
							</span>
						</div>
						<div className="td">
						<span className="sort_cont SpreadBenefit">
								<MarginSort
									sortList={props.filteredData}
									sortedColName={props.sortProps.sortedColumnState.colName}
									sortKey="SpreadBenefit"
									onSort={props.sortProps.onSort}
									colName={marginMcxHeading.spreadBenefit}
								/>
							</span>
						</div>
						<div className="td">
							<span className="sort_cont AdditionalMargin">
								<MarginSort
									sortList={props.filteredData}
									sortedColName={props.sortProps.sortedColumnState.colName}
									sortKey="AdditionalMargin"
									onSort={props.sortProps.onSort}
									colName={marginMcxHeading.additionalMargin}
								/>
							</span>
						</div>
						<div className="td">
							<span className="sort_cont TotalMargin">
								<MarginSort
									sortList={props.filteredData}
									sortedColName={props.sortProps.sortedColumnState.colName}
									sortKey="TotalMargin"
									onSort={props.sortProps.onSort}
									colName={marginMcxHeading.totalMargin}
								/>
							</span>
						</div>
						<div className="td">
						<span className="sort_cont SpecialMargin">
								<MarginSort
									sortList={props.filteredData}
									sortedColName={props.sortProps.sortedColumnState.colName}
									sortKey="SpecialMargin"
									onSort={props.sortProps.onSort}
									colName="Special Margin"
								/>
							</span>
						</div>
						<div className="td">
							<span className="sort_cont TenderMargin">
								<MarginSort
									sortList={props.filteredData}
									sortedColName={props.sortProps.sortedColumnState.colName}
									sortKey="TenderMargin"
									onSort={props.sortProps.onSort}
									colName="Tender Margin"
								/>
							</span>
						</div>
						<div className="td">
							<span className="sort_cont DeliveryMargin">
								<MarginSort
									sortList={props.filteredData}
									sortedColName={props.sortProps.sortedColumnState.colName}
									sortKey="DeliveryMargin"
									onSort={props.sortProps.onSort}
									colName="Delivery Margin"
								/>
							</span>
						</div>
						<div className="td">
							<span className="sort_cont AddtPreExpMargin">
								<MarginSort
									sortList={props.filteredData}
									sortedColName={props.sortProps.sortedColumnState.colName}
									sortKey="AddtPreExpMargin"
									onSort={props.sortProps.onSort}
									colName="Additional PreExpiry"
								/>
							</span>
						</div>
					</li>
				</ul>
				<ul className="data_rows" ref={scrollBodyRef} onScroll={() => marginScrollService(scrollBodyRef, fixedBodyRef, scrollHeadRef)}>
					{props.tableData.slice(0, props.numOfRows).map((row, index) => (
						<li className="tr" key={index}>
							<div className="td">
								<span className="LotSize ib">{toINR(row.LotSize)}</span>
							</div>
							<div className="td">
								<span className="SPANMargin ib">{toINR(row.SPANMargin)}</span>
							</div>
							<div className="td">
								<span className="ExpMargin ib">{toINR(row.ExpMargin)}</span>
							</div>
							<div className="td">
								<span className="SpreadBenefit ib">{toINR(row.SpreadBenefit)}</span>
							</div>
							<div className="td">
								<span className="AdditionalMargin ib">{toINR(row.AdditionalMargin)}</span>
							</div>
							<div className="td">
								<span className="TotalMargin ib">{toINR(row.TotalMargin)}</span>
							</div>
							<div className="td">
								<span className="SpecialMargin ib">{toINR(row.SpecialMargin)}</span>
							</div>
							<div className="td">
								<span className="TenderMargin ib">{toINR(row.TenderMargin)}</span>
							</div>
							<div className="td">
								<span className="DeliveryMargin ib">{toINR(row.DeliveryMargin)}</span>
							</div>
							<div className="td">
								<span className="AddtPreExpMargin ib">{toINR(row.AddtPreExpMargin)}</span>
							</div>
						</li>
					))}
				</ul>
			</div>
		</div>
	);
};

export default MarginMcxTableMob;
